require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');


// WEBPACK FOOTER //
// ./build/modules/slider.js